import { AuthBrandLogo } from '../../features/auth/AuthBrandLogo';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './OrganizationCreatedPage.css'; // 既存のスタイルを再利用

export default function OrganizationJoinRequestedPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const organizationName = location.state?.organizationName || '組織';

  // GTM dataLayer イベント送信（Google広告CV計測用）
  // PII (組織名等) は GA4/Google Ads へ送らないため event 名のみを積む。
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'organization_join_requested',
    });
  }, []);

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <AuthBrandLogo />
        <div className="auth-card">
          <div className="auth-header">
            <img src="/check_2_green.svg" alt="完了" className="success-check-icon" />
            <h1 className="auth-title">参加依頼を送信しました</h1>
            <p className="auth-subtitle">
              {organizationName} への参加依頼が完了しました
            </p>
          </div>

          <div className="auth-content">
            <div className="success-message">
              <p>
                参加依頼が組織の管理者に送信されました。
                <br />
                管理者が承認すると、組織の機能をご利用いただけます。
              </p>
              <p>
                承認されるとメールでお知らせします。
              </p>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn btn-primary btn-large"
                onClick={handleGoHome}
              >
                ホームに戻る
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
